export const HAS_BORDER_AT_CHECKOUT_STYLES = `
  padding: 1.5rem 2rem 1rem;
  border-radius: 0px;
  border: 1px solid ${Styles.color.grey.three};
`;
